import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);

// const hostname = window.location.hostname;
// console.log('hostname:' + hostname);

declare global {
  interface Window {
    onFlutterFCMTokenReceived: (token: string) => void;
  }
}

window.onFlutterFCMTokenReceived = function (token: string) {
  console.log("Received FCM Token in WebView:", token);
  localStorage.setItem("fcmToken", token);
};
